import React, { Fragment, useEffect, useState } from "react";
import { P } from "../../../AbstractElements";
import { Col } from "reactstrap";
import { India, KolKata } from "../../../Constant";
import { ClockData } from "../../../Data/Widgets/general/ClockData";
import Clock from "react-clock";

const MobileWidgets = () => {
  const [value, setValue] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setValue(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <Fragment>
      <Col xl="5" md="6">
        <div className="mobile-clock-widget">
          <div>
            <Clock value={value} />
            <div id="date" className="date f-24 mb-2">
              <span className="flex-grow-1">{ClockData.dateShow}</span>
              <P className="m-0 f-14 text-light">
                {KolKata}, {India}
              </P>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};
export default MobileWidgets;
